import { jointReportConstants } from "_constants";
import { REHYDRATE } from "redux-persist/lib/constants";
import { produce } from "immer";
let initState = {
  current: {},
  my: [],
  shared: [],
  fields: {},
  data: {
    all: {},
    count: 0,
    loading: false,
  },
  scoreboard: {},
  aList: {
    loading: false,
  },
  remittance: {
    loading: false,
    all: {},
    error: null,
  },
  remittanceTemplate: {
    loading: false,
    template: null,
    variables: null,
    additionalColumns: [],
    error: null,
  },
};
export function reports(state = { ...initState }, action) {
  const { payload, type } = action;

  switch (type) {
    case jointReportConstants.GET_USER_REPORTS_SUCCESS:
      return produce(state, (draft) => {
        draft["my"] = [...payload.userReports];
        draft["shared"] = [...payload.sharedReports];
      });
    case jointReportConstants.GET_REPORT_SUCCESS:
      return produce(state, (draft) => {
        const { data } = payload;
        draft["current"] = { ...data };
      });
    case jointReportConstants.GET_REPORT_PROCS_SUCCESS:
      return produce(state, (draft) => {
        draft["fields"] = {...payload};
      })
    case jointReportConstants.QUERY_REPORT_PROC_SUCCESS:
      return produce(state, (draft) => {
        let { data } = payload;
        draft["data"]["all"] = [...data.data];
        draft["data"]["count"] = data.count;
        draft["data"]["loading"] = false;
      });
    case jointReportConstants.QUERY_REPORT_PROC_LOADING:
      return produce(state, (draft) => {
        draft["data"]["loading"] = true;
      });
    case jointReportConstants.GET_SCORE_BOARD_SUCCESS:
      return produce(state, (draft) => {
        draft["scoreboard"] = payload;
      });
    case jointReportConstants.GET_A_LIST_REPORT_SUCCESS:
      return produce(state, (draft) => {
        let { data, marketId, regionId, entityId } = payload;

        let key = `${regionId}-${marketId}-${entityId}`;

        draft["aList"] = { [key]: data, loading: false };
      });
    case jointReportConstants.GET_A_LIST_REPORT_LOADING_TRUE:
      return produce(state, (draft) => {
        draft["aList"] = { loading: true };
      });

    case jointReportConstants.GET_REMITTANCE_REQUEST:
      return produce(state, (draft) => {
        if (!draft.remittance) {
          draft.remittance = { loading: false, all: {}, error: null };
        }
        draft.remittance.loading = true;
        draft.remittance.error = null;
      });
    case jointReportConstants.GET_REMITTANCE_SUCCESS:
      return produce(state, (draft) => {
        const { entityIDs, data } = payload;
        entityIDs.forEach((entityID) => {
          draft.remittance.all[entityID] = data[entityID];
        });
        draft.remittance.loading = false;
      });
    case jointReportConstants.GET_REMITTANCE_FAILURE:
      return produce(state, (draft) => {
        draft.remittance.loading = false;
        draft.remittance.error = payload.error;
      });
    case jointReportConstants.GET_REMITTANCE_CLEAR:
      return produce(state, (draft) => {
        draft.remittance.loading = false;
        draft.remittance.all = {};
      });
    case jointReportConstants.GET_REMITTANCE_TEMPLATE_REQUEST:
      return produce(state, (draft) => {
        // Ensure remittanceTemplate exists
        if (!draft.remittanceTemplate) {
          draft.remittanceTemplate = {
            loading: false,
            template: null,
            variables: null,
            additionalColumns: [],
            error: null,
          };
        }
        draft.remittanceTemplate.loading = true;
        draft.remittanceTemplate.error = null;
      });

    case jointReportConstants.GET_REMITTANCE_TEMPLATE_SUCCESS:
      return produce(state, (draft) => {
        // Ensure remittanceTemplate exists
        if (!draft.remittanceTemplate) {
          draft.remittanceTemplate = {
            loading: false,
            template: null,
            variables: null,
            additionalColumns: [],
            error: null,
          };
        }
        draft.remittanceTemplate.loading = false;
        draft.remittanceTemplate.template = payload.data.letterTemplate;
        draft.remittanceTemplate.variables = {
          addressLine1: payload.data.addressLine1 || "",
          addressLine2: payload.data.addressLine2 || "",
          addressLine3: payload.data.addressLine3 || "",
          addressLine4: payload.data.addressLine4 || "",
          addressTo: payload.data.addressTo || "",
          detailsLabel: payload.data.detailsLabel || "",
          paidBy: payload.data.paidBy || "",
          docName: payload.data.docName || "",
        };
        draft.remittanceTemplate.additionalColumns = payload.data.additionalColumns || [];
      });

    case jointReportConstants.GET_REMITTANCE_TEMPLATE_FAILURE:
      return produce(state, (draft) => {
        // Ensure remittanceTemplate exists
        if (!draft.remittanceTemplate) {
          draft.remittanceTemplate = {
            loading: false,
            template: null,
            variables: null,
            additionalColumns: [],
            error: null,
          };
        }
        draft.remittanceTemplate.loading = false;
        draft.remittanceTemplate.error = payload.error;
      });

    case jointReportConstants.UPDATE_REMITTANCE_TEMPLATE_REQUEST:
      return produce(state, (draft) => {
        // Ensure remittanceTemplate exists
        if (!draft.remittanceTemplate) {
          draft.remittanceTemplate = {
            loading: false,
            template: null,
            variables: null,
            additionalColumns: [],
            error: null,
          };
        }
        draft.remittanceTemplate.loading = true;
        draft.remittanceTemplate.error = null;
      });

    case jointReportConstants.UPDATE_REMITTANCE_TEMPLATE_SUCCESS:
      return produce(state, (draft) => {
        // Ensure remittanceTemplate exists
        if (!draft.remittanceTemplate) {
          draft.remittanceTemplate = {
            loading: false,
            template: null,
            variables: null,
            additionalColumns: [],
            error: null,
          };
        }
        draft.remittanceTemplate.loading = false;

        // Update template if it was changed
        if (payload.data.letterTemplate) {
          draft.remittanceTemplate.template = payload.data.letterTemplate;
        }

        // Update variables if they were changed
        if (payload.templateData) {
          Object.keys(payload.templateData).forEach((key) => {
            if (draft.remittanceTemplate.variables && draft.remittanceTemplate.variables.hasOwnProperty(key)) {
              draft.remittanceTemplate.variables[key] = payload.templateData[key];
            }
          });
        }
      });

    case jointReportConstants.UPDATE_REMITTANCE_TEMPLATE_FAILURE:
      return produce(state, (draft) => {
        // Ensure remittanceTemplate exists
        if (!draft.remittanceTemplate) {
          draft.remittanceTemplate = {
            loading: false,
            template: null,
            variables: null,
            additionalColumns: [],
            error: null,
          };
        }
        draft.remittanceTemplate.loading = false;
        draft.remittanceTemplate.error = payload.error;
      });

    case jointReportConstants.REVERT_REMITTANCE_TEMPLATE_REQUEST:
      return produce(state, (draft) => {
        draft.remittanceTemplate.loading = true;
        draft.remittanceTemplate.error = null;
      });

    case jointReportConstants.REVERT_REMITTANCE_TEMPLATE_SUCCESS:
      return produce(state, (draft) => {
        draft.remittanceTemplate.loading = false;
        draft.remittanceTemplate.template = payload.template;
      });

    case jointReportConstants.REVERT_REMITTANCE_TEMPLATE_FAILURE:
      return produce(state, (draft) => {
        draft.remittanceTemplate.loading = false;
        draft.remittanceTemplate.error = payload.error;
      });

    case jointReportConstants.CLEAR_REMITTANCE_TEMPLATE:
      return produce(state, (draft) => {
        draft.remittanceTemplate = {
          loading: false,
          template: null,
          variables: null,
          additionalColumns: [],
          error: null,
        };
      });
    case REHYDRATE: {
      if (payload && payload.joint && payload.joint.reports) {
        // Ensure the rehydrated state has the proper structure
        const rehydratedState = { ...payload.joint.reports };

        if (!rehydratedState.remittanceTemplate) {
          rehydratedState.remittanceTemplate = {
            loading: false,
            template: null,
            variables: null,
            additionalColumns: [],
            error: null,
          };
        }

        if (!rehydratedState.remittance) {
          rehydratedState.remittance = {
            loading: false,
            all: {},
            error: null,
          };
        }

        return rehydratedState;
      } else {
        return { ...initState };
      }
    }
    case jointReportConstants.JOINT_REPORTS_CLEAR:
      return {
        ...initState,
      };
    default:
      return state;
  }
}
